import { createSimpleFunctional } from '@/util'

export default createSimpleFunctional('v-list-img')
